export default "__VITE_ASSET__CMK04JTG__"